import { useContext, useEffect, useState } from "react";
import { haveValue } from "../helper/common";
import { Outlet, useParams } from "react-router-dom";
import AuthContext from "../context/auth/AuthContext";

const AuthRefresh = () => {
  const [loggedInId, setLoggedInId] = useState(null);
  const { workspaceId } = useParams;
  const { user } = useContext(AuthContext);

  useEffect(() => {
    const interval = setInterval(() => {
      const localId = localStorage.getItem("saveduserid");

      if (!haveValue(localId) && haveValue(loggedInId)) {
        setLoggedInId(null);
      }

      if (!haveValue(loggedInId) && haveValue(localId)) {
        setLoggedInId(localId);
      }
      if (haveValue(loggedInId) && haveValue(localId)) {
        if (loggedInId != localId) {
          window.location.replace(
            user?.role === "landlord" && haveValue(workspaceId)
              ? `${window.location.protocol}//${process.env.REACT_APP_URL_NAME}/${workspaceId}/home`
              : `${window.location.protocol}//${process.env.REACT_APP_URL_NAME}/home`
          );
        }
      }
    }, 1000);

    return () => clearInterval(interval); // 🧹 Clean up on unmount
  }, []);
  return (
    <>
      <Outlet />
    </>
  );
};

export default AuthRefresh;
